import { render } from "./ShareDialogPropsCmp.vue?vue&type=template&id=0dea13d6"
import script from "./ShareDialogPropsCmp.vue?vue&type=script&lang=js"
export * from "./ShareDialogPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__